// src/features/scheduleGenerator/ScheduleGeneratorContext.tsx
import { createContext, useContext } from 'react';
import { ScheduleGeneratorHookContext } from './hooks/useScheduleGenerator';
import { logError } from '../../utils/logger';

// Define the shape of the trigger function with optional callbacks
export interface ScheduleGeneratorTriggerOptions {
  onClose?: () => void;
  onDataRefresh?: () => void;
  /** 計畫套用完成後的回調（供 Lesson 2 引導標記完成用） */
  onPlanApplied?: () => void;
}

export type ScheduleGeneratorTriggerFunction = (
  context: ScheduleGeneratorHookContext,
  options?: ScheduleGeneratorTriggerOptions
) => void;

export interface DayDraftOptions {
  onApplied?: () => void;
}

// Define the context type
interface ScheduleGeneratorContextType {
  triggerAIPlan: ScheduleGeneratorTriggerFunction;
  triggerDayDraft: (options?: DayDraftOptions) => void;
}

// Create the context with a default dummy function to avoid errors
export const ScheduleGeneratorContext = createContext<ScheduleGeneratorContextType>({
  triggerAIPlan: () => {
    logError('ScheduleGeneratorContext', 'triggerAIPlan called outside of ScheduleGeneratorProvider');
  },
  triggerDayDraft: (_options?: DayDraftOptions) => {
    logError('ScheduleGeneratorContext', 'triggerDayDraft called outside of ScheduleGeneratorProvider');
  },
});

// Custom hook for easy consumption of the context
export const useScheduleGeneratorTrigger = () => {
  return useContext(ScheduleGeneratorContext);
};
